export enum CreateTreatmentInvoiceResult {
  Confirmed = 0,
  Success = 1,
  CostMismatch = 2,
  PaidFailed = 3,
}
